export enum BudgetEntity {
Budget,
BudgetAdjustment,
SpendingRequest,
Invoice,
PaymentOrder,
Payment,
IncomeReceipt,
SettlementPaymentOrder,
}
